// GENERATED by gb-backend/scripts/i18n/core.js — haath se mat badlo.
// Entry chunk (index.js ke static imports) jo keys maangta hai, sirf wahi — 400 key.
// Poora pack hi-Latn.js alag chunk hai. Dobara banao: node scripts/i18n/core.js --write
const dict = {
  "api.bad_server_response_status": "Bad server response ({status})",
  "api.session_expired": "Session expired",
  "app.0_margin": "0% margin",
  "app.0_overdue": "0 overdue",
  "app.0_projects": "0 projects",
  "app.0_total": "0 total",
  "app.10_digit_mobile": "10-digit mobile",
  "app.3_low_stock": "3 low-stock",
  "app.aapka_ai_assistant_live_data_ke": "Aapka AI assistant — live data ke saath",
  "app.aapka_mobile_in_companies_me_registered": "Aapka mobile in companies me registered hai — kisi se bhi shuru karo. Login ke baad app ke andar se baaki companies me bina dobara login kiye switch kar sakte ho.",
  "app.aapka_password_abhi_default_hai_surakshit": "Aapka password abhi default hai — security ke liye naya password set karo.",
  "app.active_projects": "Active Projects",
  "app.active_tasks": "Active Tasks",
  "app.all_construction_projects": "All Construction Projects",
  "app.all_reports": "All Reports",
  "app.alt_sc": "Alt+{sc}",
  "app.assets": "Assets",
  "app.assets_sub": "Tools, shuttering, props — kahan hai, kiske paas",
  "app.attendance_today": "attendance today",
  "app.bid_emd_bg_agreement_dlp": "Bid · EMD/BG · Agreement · DLP",
  "app.billed_invoiced": "Billed (invoiced)",
  "app.billing_abhi_shuru_nahi_hui": "Billing abhi shuru nahi hui",
  "app.boq_value": "BOQ Value",
  "app.budget_used": "Budget Used",
  "app.business_management_platform": "Business Management Platform",
  "app.cash_book_transactions": "Cash Book · Transactions",
  "app.cash_flow_trend": "Cash Flow Trend",
  "app.cash_position": "Cash Position",
  "app.central_stock": "Central Stock",
  "app.city_boq_fmt": "{city} · BOQ ₹{fmt}",
  "app.city_optional": "City (optional)",
  "app.city_tasks_pm_pm": "{city} · {tasks} · PM {pm}",
  "app.click_for_detail": "click for detail",
  "app.client": "Client",
  "app.clients_leads": "Clients & Leads",
  "app.commercial_solar": "Commercial Solar",
  "app.company_name": "Company name",
  "app.company_overview": "Company Overview",
  "app.configuration": "Configuration",
  "app.confirm_password": "Confirm Password",
  "app.construction": "Construction",
  "app.cost_incurred": "Cost incurred",
  "app.cost_overrun": "Cost overrun",
  "app.create_new_company": "Create New Company",
  "app.creating": "Creating...",
  "app.ctrl_k": "Ctrl+K",
  "app.ctrl_k_to_open_anytime": "Ctrl+K to open anytime",
  "app.details": "Details",
  "app.dev_otp": "DEV OTP:",
  "app.dhyaan_chahiye": "Attention chahiye",
  "app.diesel_barrel_stock_machine_consumption": "Diesel, barrel stock & machine consumption",
  "app.dono_passwords_match_nahi_kar_rahe": "Dono passwords match nahi kar rahe",
  "app.drawings_tasks": "Drawings & Tasks",
  "app.end": "Khatam",
  "app.enter_a_valid_10_digit_mobile": "Enter a valid 10-digit mobile number",
  "app.enter_otp_4_digit": "Enter OTP (4-digit)",
  "app.enter_password": "Enter password",
  "app.enter_the_otp": "Enter the OTP",
  "app.equip": "Equip",
  "app.expense": "Expense",
  "app.expense_breakdown": "Expense Breakdown",
  "app.expense_till_date": "Expense till date",
  "app.finance_overview": "Finance Overview",
  "app.financials": "Financials",
  "app.flags": "Flags",
  "app.fleet_health_service_documents_reminders": "Fleet health, service, documents & reminders",
  "app.fuel": "Fuel",
  "app.gantt_timesheets": "Gantt · Timesheets",
  "app.general": "General",
  "app.global_navigation_alt_key": "Global Navigation (Alt + Key)",
  "app.government_contractor": "Government Contractor",
  "app.gross_margin": "Gross Margin",
  "app.home": "Home",
  "app.housing_projects": "Housing Projects",
  "app.individual_contractor": "Individual Contractor",
  "app.invalid_otp": "Invalid OTP",
  "app.invoiced": "Invoiced",
  "app.invoiced_received_expense": "Invoiced · Received · Expense",
  "app.invoiced_till_date": "Invoiced till date",
  "app.keyboard_shortcuts": "Keyboard Shortcuts",
  "app.keyboard_shortcuts_2": "Keyboard Shortcuts (?)",
  "app.koi_recent_task_nahi": "Koi recent task nahi",
  "app.last_7_days": "Last 7 days",
  "app.leave": "Leave",
  "app.length_total": "{length} total",
  "app.less": "Less",
  "app.loading_module": "Loading module...",
  "app.logging_in": "Logging in...",
  "app.login": "Login",
  "app.login_with_otp": "Login with OTP",
  "app.login_with_password": "Login with Password",
  "app.logout": "Logout",
  "app.loss": "ghaata",
  "app.low_stock_items": "Low Stock Items",
  "app.machinery": "Machinery",
  "app.master_data": "Master Data",
  "app.material_requests": "Material Requests",
  "app.min_6_characters": "Min 6 characters",
  "app.minutes_of_meeting": "Minutes of Meeting",
  "app.mobile_number": "Mobile Number",
  "app.monthly_spend_trend": "Monthly Spend Trend",
  "app.more": "More",
  "app.more_modules": "More Modules",
  "app.my_profile": "My Profile",
  "app.my_team": "My Team",
  "app.name_module_disabled": "{name} — Module Disabled",
  "app.new_password": "New Password",
  "app.new_password_kam_se_kam_6": "New password kam se kam 6 characters ka ho",
  "app.next": "Next",
  "app.next_invoice_milestone": "Next invoice · {milestone}",
  "app.next_task": "Next task",
  "app.no_data_yet": "No data yet",
  "app.no_expense_recorded": "Is project par abhi koi expense darj nahi",
  "app.no_pending_issues": "✓ No pending issues",
  "app.no_results_for_q": "No results for \"{q}\"",
  "app.no_spend_last_6_months": "Pichhle 6 mahine me koi expense nahi",
  "app.no_transactions_yet": "No transactions yet",
  "app.on_leave": "On Leave",
  "app.on_time": "on time",
  "app.operations_team": "Operations & Team",
  "app.otp_could_not_be_sent_please": "OTP could not be sent. Please try again.",
  "app.otp_sms_pehchan": "SMS kisi aur naam (jaise 'Dashanan') se aa sakta hai aur signup jaisa likha ho sakta hai — usme jo 6 digit ka number hai, wahi aapka OTP hai.",
  "app.outstanding": "Outstanding",
  "app.overduetasks_overdue": "{overdueTasks} overdue",
  "app.password": "Password",
  "app.payables": "Payables",
  "app.pending_actions": "Pending Actions",
  "app.pending_approvals": "Pending Approvals",
  "app.pending_issues": "Pending issues",
  "app.physical_progress": "Physical progress",
  "app.platform_management": "Platform Management",
  "app.pm": "PM",
  "app.po_rfq_materials": "PO · RFQ · Materials",
  "app.present_today": "Present Today",
  "app.procurement_pipeline": "Procurement Pipeline",
  "app.profit": "munafa",
  "app.progress_vs_billing_vs_cost": "Progress vs Billing vs Cost",
  "app.project_detail_tabs_ctrl_key": "Project Detail Tabs (Ctrl + Key)",
  "app.project_overview": "Project Overview",
  "app.project_progress": "Project Progress",
  "app.project_wise_updates": "Project-wise updates",
  "app.projects_overview": "Projects Overview",
  "app.purchase": "Purchase",
  "app.qs_detail": "Detail",
  "app.qs_fleet": "Fleet (apni / Machinery)",
  "app.qs_gaadi": "Gaadi",
  "app.qs_trip_gaadi": "Trip gaadi (bina vendor)",
  "app.qs_trip_vehicles": "Trips & Billing",
  "app.quick_search_ctrl_k": "Quick Search (Ctrl+K)",
  "app.real_estate_projects_sales": "Real-Estate Projects & Sales",
  "app.realized_margin": "Realized margin",
  "app.receivables": "Receivables",
  "app.recent_activity": "Recent Activity",
  "app.reorder_needed": "Reorder needed",
  "app.resend_otp": "Resend OTP",
  "app.revenue": "Revenue",
  "app.rmc": "Production Plant",
  "app.rmc_sub": "Plant ka production — order, challan, site par accept",
  "app.saas_admin": "SaaS Admin",
  "app.saas_leads": "SaaS Leads",
  "app.sahayak_ai": "Sahayak AI",
  "app.sahayak_ai_kuch_bhi_poochein": "Sahayak AI — kuch bhi poochein",
  "app.sales_pipeline": "Sales Pipeline",
  "app.sanchalan": "Sanchalan",
  "app.sanchalan_press_to_toggle": "Sanchalan — Press ? to toggle",
  "app.save": "Save",
  "app.search": "Search",
  "app.search_modules_navigate_enter_select": "Search modules... (↑↓ navigate, Enter select)",
  "app.select_company": "Select company",
  "app.sending_otp": "OTP bhej raha hai…",
  "app.server_not_reachable_please_try_again": "Server not reachable. Dobara try karo.",
  "app.set_a_new_password": "Naya password set karo",
  "app.set_new_password_continue": "Naya password set karo & Continue karo",
  "app.settings_module_access": "Settings → Module Access",
  "app.shortcuts_are_disabled_when_typing_in": "Shortcuts disabled hain jab input fields me type kar rahe ho",
  "app.site_activity_pulse": "Site Activity (Pulse)",
  "app.site_exp": "Site Exp",
  "app.site_mapping": "Site Mapping",
  "app.site_mapping_sub": "Site ki map library — folder, file aur marking",
  "app.spent": "Spent",
  "app.staff_payments": "Staff Payments",
  "app.sub_con": "Sub-Con",
  "app.surya_ghar_other_solar": "Surya Ghar + Other Solar",
  "app.surya_ghar_yojana": "Surya Ghar Yojana",
  "app.switch_karo": "Switch karo",
  "app.switching_company": "Company switch ho rahi hai…",
  "app.team_attendance_today": "Team Attendance — Today",
  "app.team_hr": "Team & HR",
  "app.tenders": "Tenders",
  "app.this_module_is_not_enabled_for": "This module is not enabled for your company. Contact your administrator to enable it from Settings → Module Access.",
  "app.to_review": "to review",
  "app.total_boq": "Total BOQ",
  "app.total_received": "Total Received",
  "app.total_spent": "Total Spent",
  "app.township_crm": "Township CRM",
  "app.under_billed": "Under-billed",
  "app.verify_login": "Verify & Login",
  "app.verifying": "Verify ho raha hai…",
  "app.view_all": "View all",
  "app.your_account": "Your Account",
  "app.your_companies": "Your Companies",
  "app_error_boundary.reload_app": "Reload App",
  "capacitor_init.exit_sanchalan": "Exit Sanchalan?",
  "cexp.account": "Kis khaate se",
  "cexp.account_ph": "Khaata select karo",
  "cexp.add_another": "Ek aur daalo",
  "cexp.amount": "Rakam (₹)",
  "cexp.bill_file": "Bill photo / PDF",
  "cexp.bill_no": "Bill no.",
  "cexp.bill_no_ph": "Bill / consumer no.",
  "cexp.cancel": "Rehne do",
  "cexp.close": "Band karo",
  "cexp.company_hint": "Kisi office ya project ka nahi (jaise CA fees, company ka insurance).",
  "cexp.date": "Bill / kharche ki date",
  "cexp.done_ok": "Expense #{id} save ho gaya",
  "cexp.done_ok_sub": "Ab khaaton me dikh raha hai.",
  "cexp.done_pending": "Expense #{id} approval me gaya",
  "cexp.done_pending_sub": "Balance approval ke baad hi badlega — Pending Approvals me dekho.",
  "cexp.due": "Dene ki aakhri tareekh",
  "cexp.eff_after_approval": "Asar approval ke baad hi.",
  "cexp.eff_due": "{date} tak dena hai.",
  "cexp.eff_paid": "{acc} se {amt} jaayega (Cash Book me dikhega).",
  "cexp.eff_party_paid": "{party} ke khaate me {amt} jama — wo humein {amt} kam denge (ya hum unke karzdaar). Cash nahi hilta.",
  "cexp.eff_payable": "{party} ka {amt} baaki banega — baad me Payment Made se chukao.",
  "cexp.estimate": "andaaz {amt}",
  "cexp.file_change": "Badlo",
  "cexp.file_pick": "File select karo",
  "cexp.file_view": "Dekho",
  "cexp.from_library": "Expense Library se: {name} · {period}",
  "cexp.grp_office": "Office",
  "cexp.grp_store": "Store",
  "cexp.gst": "GST rakam (₹)",
  "cexp.head": "Kharche ka head",
  "cexp.head_add": "Add karo",
  "cexp.head_add_fail": "Head nahi juda",
  "cexp.head_new": "Naya head",
  "cexp.head_new_ph": "Naye head ka naam (jaise Bijli)",
  "cexp.head_ph": "Bijli, kiraya, internet…",
  "cexp.itc": "Input credit (ITC) milega",
  "cexp.loc_no_city_hint": "Is jagah ki city nahi lagi — Settings → Locations me lagao, taaki city-wise report sahi aaye.",
  "cexp.loc_ph": "Office / store select karo",
  "cexp.mode_paid": "Humne abhi bhara",
  "cexp.mode_paid_sub": "Khaate / cash se paisa gaya",
  "cexp.mode_party_paid": "Party ne bhara",
  "cexp.mode_party_paid_sub": "Party ne hamari jagah bhara — unke khaate me jama, bina cash",
  "cexp.mode_payable": "Baad me dena hai",
  "cexp.mode_payable_sub": "Bill aaya — vendor ka baaki, aakhri tareekh ke saath",
  "cexp.mop": "Tarika",
  "cexp.mop_cash": "Cash",
  "cexp.mop_cheque": "Cheque",
  "cexp.mop_neft": "Bank / NEFT",
  "cexp.mop_upi": "UPI",
  "cexp.need_account": "Khaata select karo",
  "cexp.need_amount": "Rakam likho",
  "cexp.need_date": "Date select karo",
  "cexp.need_force": "\"Dohra nahi hai\" tick karo ya entry badlo",
  "cexp.need_force_why": "Likho ki dohra kyun nahi hai",
  "cexp.need_head": "Head select karo",
  "cexp.need_loc": "Office / store select karo",
  "cexp.need_party": "Party select karo",
  "cexp.need_project": "Project select karo",
  "cexp.no_city": "City nahi lagi",
  "cexp.no_locs": "Abhi koi office / store nahi — Settings → Locations me city ke saath add karo.",
  "cexp.not_dup": "Dohra nahi hai — phir bhi save karo",
  "cexp.not_dup_why": "Alag kyun hai?",
  "cexp.note": "Note",
  "cexp.note_ph": "jaise Oct ka bill, meter 1234",
  "cexp.party_paid_by": "Kis party ne bhara",
  "cexp.party_payable": "Kisko dena hai (party)",
  "cexp.party_ph": "Party select karo",
  "cexp.payee": "Kisko diya (zaroori nahi)",
  "cexp.payee_ph": "jaise CSPDCL, makaan maalik",
  "cexp.period": "Kis mahine ka",
  "cexp.period_tip": "Expense kis mahine ka hai — jaise September ka bill October me bhara",
  "cexp.project_ph": "Project select karo",
  "cexp.save": "Approval ke liye bhejo",
  "cexp.save_fail": "Save nahi hua",
  "cexp.saving": "Save ho raha…",
  "cexp.staff_hint": "Staff ne apne wallet se bhara? Wo entry Mera wallet se karo.",
  "cexp.subtitle": "Kis head me · kahan ka · kisne bhara — approval me jaata hai",
  "cexp.tax_blank": "Na ho to empty chhodo",
  "cexp.tax_toggle": "GST / TDS (zaroori nahi)",
  "cexp.tds": "TDS rakam (₹)",
  "cexp.title": "Company Expense",
  "cexp.upload_fail": "Upload nahi hua",
  "cexp.uploading": "Upload ho raha…",
  "cexp.where": "Kahan ka expense",
  "cexp.where_company": "Poori company",
  "cexp.where_loc": "Office / Store",
  "cexp.where_project": "Project",
  "cexp.who_paid": "Paisa kisne diya?",
  "common.absent": "Absent",
  "common.all": "All",
  "common.back": "Back",
  "common.back_discard_form": "Form band karein? Jo bhara hai wo chala jayega.",
  "common.cancel": "Cancel",
  "common.change": "Change",
  "common.city": "City",
  "common.collapse": "Collapse karo",
  "common.company": "Company",
  "common.confirm": "Confirm karo",
  "common.create": "Create",
  "common.dashboard": "Dashboard",
  "common.delete": "Delete karo",
  "common.design": "Design",
  "common.dismiss": "Dismiss karo",
  "common.finance": "Finance",
  "common.just_now": "just now",
  "common.library": "Library",
  "common.margin": "Margin",
  "common.material": "Material",
  "common.material_requests": "Material Requests",
  "common.net": "Net",
  "common.on_track": "On track",
  "common.payroll": "Payroll",
  "common.pending_approvals": "Pending Approvals",
  "common.present": "Present",
  "common.procurement": "Procurement",
  "common.progress": "Progress",
  "common.projects": "Projects",
  "common.received": "Received",
  "common.refresh": "Refresh",
  "common.remove": "Remove",
  "common.reports": "Reports",
  "common.reset": "Reset",
  "common.retry": "Retry",
  "common.save": "Save karo",
  "common.saving": "Save ho raha hai...",
  "common.search": "Search karo...",
  "common.settings": "Settings",
  "common.start": "Start",
  "common.type": "Type",
  "common.unbilled": "Unbilled",
  "common.user": "User",
  "common.warehouse": "Store",
  "confirm_dialog.continue": "Continue",
  "confirm_dialog.yes_cancel": "Yes, Cancel",
  "ecl.action_fail": "Nahi hua",
  "ecl.all": "Sab",
  "ecl.cancel": "Rehne do",
  "ecl.close": "Band karo",
  "ecl.company": "Company",
  "ecl.due": "{date} tak",
  "ecl.empty_all": "Is mahine koi dohrane wala expense nahi.",
  "ecl.empty_hint": "Dohrane wale kharche Library → Expense Library me add karo.",
  "ecl.empty_mine": "Is mahine aapke zimme koi expense nahi.",
  "ecl.fixed": "fix",
  "ecl.future": "Ye mahina abhi shuru nahi hua.",
  "ecl.load_fail": "List nahi aayi",
  "ecl.loading": "Aa raha hai…",
  "ecl.make": "Bana do",
  "ecl.mine": "Mere",
  "ecl.mode_paid": "hum bharte",
  "ecl.mode_party_paid": "party bharti",
  "ecl.mode_payable": "bill, baad me dena",
  "ecl.next": "Agla mahina",
  "ecl.no_due": "Tareekh nahi",
  "ecl.overdue_tag": "tareekh nikal gayi",
  "ecl.prev": "Pichhla mahina",
  "ecl.resp": "zimmedaar {name}",
  "ecl.skip": "Is mahine nahi",
  "ecl.skip_ok": "Chhodo",
  "ecl.skip_why_ph": "Is mahine kyun nahi? (jaise office band)",
  "ecl.skip_why_req": "Likho ki is mahine kyun nahi chahiye",
  "ecl.st_done": "ho gaya",
  "ecl.st_in_approval": "approval me",
  "ecl.st_pending": "baaki",
  "ecl.st_skipped": "chhoda",
  "ecl.st_to_pay": "dena baaki",
  "ecl.subtitle": "Expense Library se — is mahine kya aana hai, kya ho gaya",
  "ecl.sum_overdue": "tareekh nikli",
  "ecl.sum_total": "kul",
  "ecl.title": "Mahine ke kharche",
  "ecl.to_pay_amt": "{amt} dena baaki",
  "ecl.unskip": "Wapas lao",
  "ecl.variable": "har baar alag",
  "enudge.body": "Aapke zimme ke is mahine ke {n} kharche ki entry abhi nahi hui.",
  "enudge.later": "Baad me",
  "enudge.more": "+{n} aur",
  "enudge.open": "List kholo",
  "enudge.overdue": "{n} ki tareekh nikal gayi.",
  "enudge.title": "Mahine ke kharche baaki",
  "notification_bell.mark_all_read": "Mark all read",
  "notification_bell.no_new_notifications": "No new notifications",
  "notification_bell.notifications": "Notifications",
  "search_select.chuno": "Select karo…",
  "search_select.no_match_found": "Koi match nahi mila",
  "search_select.no_options_yet": "Abhi koi options nahi hain",
  "upload_toast.queued": "Queued",
  "upload_toast.upload_complete": "Upload complete",
  "web_push.bell_hint": "Is computer par bhi notification chahiye? Sanchalan ka tab band ho tab bhi aayega",
  "web_push.denied": "Browser ne band kar rakha hai — address bar me 🔒 par click karke Notifications → Allow karo, phir page refresh karo",
  "web_push.done": "Chalu ho gaya — ab Sanchalan ka tab band ho tab bhi notification aayega",
  "web_push.enable": "Chalu karo",
  "web_push.failed": "Chalu nahi ho paaya — net dekh kar dobara koshish karo",
  "web_push.label": "Is browser par notification",
  "web_push.later": "Baad me",
  "web_push.ok": "Theek hai",
  "web_push.on": "Chalu hai",
  "web_push.unsupported": "Ye browser notification nahi deta",
};

export default dict;
